"use client";

import React from "react";
import { NextFont } from "next/dist/compiled/@next/font";

const HeadStyle: React.FC<{ font: NextFont }> = ({ font }) => {
  return (
    // eslint-disable-next-line react/no-unknown-property
    <style global jsx>{`
      html,
      body {
        font-family: ${font.style.fontFamily} !important;
      }
    `}</style>
  );
};

export default HeadStyle;
